import { render, staticRenderFns } from "./VehiculosPorServicioTab.vue?vue&type=template&id=09e460ae&scoped=true&"
import script from "./VehiculosPorServicioTab.vue?vue&type=script&lang=js&"
export * from "./VehiculosPorServicioTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e460ae",
  null
  
)

export default component.exports